import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      '到店礼'
    ]

    return (
      <HeaderView title="到店礼" header={header}>
        <div style={{ padding: 40 }}>
          <img src="http://qnm.hunliji.com/o_1aaggsme8935vg1qbg1t5k1ovtn.jpg" />
          <img src="http://qnm.hunliji.com/o_1aaggsme81bjmubdaml1hnd16gbo.jpg" />
          <img src="http://qnm.hunliji.com/o_1aagiid3l1a4hu5f1osh1lfe11ac7.jpg" />
          <img src="http://qnm.hunliji.com/o_1aaggniqu10m81tmd113t19gae5ub.jpg" />
        </div>
      </HeaderView>
    )
  }
}
